/** React */
import React, { ReactNode, createContext, useState } from "react";

/** Wrapper */
import { MenuWrapper } from "./menu-wrapper";

/** Types */
type Item = {
  id: string;
  isExpanded: boolean;
};

/** Context type */
type MenuContextType = {
  items: Record<string, Item>;
  addItem: (item: Item) => void;
  toggle: (id: string) => void;
};

/** Context */
const MenuContext = createContext({} as MenuContextType);

/** Props */
type MenuRootProps = {
  children: ReactNode;
  isOpenByDefault?: true;
};

export function MenuRoot({ children, isOpenByDefault }: MenuRootProps) {
  const [items, setItems] = useState<Record<string, Item>>({});

  const addItem = (item: Item) => {
    setItems((state) => ({
      ...state,
      [item.id]: {
        ...item,
        isExpanded: isOpenByDefault || false,
      },
    }));
  };

  const toggle = (id: string) => {
    setItems((state) => ({
      ...state,
      [id]: {
        ...items[id],
        isExpanded: !items[id].isExpanded || false,
      },
    }));
  };

  return (
    <MenuContext.Provider value={{ items, addItem, toggle }}>
      <MenuWrapper>{children}</MenuWrapper>
    </MenuContext.Provider>
  );
}

export function useMenu() {
  if (MenuContext === undefined) {
    throw new Error("useMenu must be used within a MenuContext Provider");
  }

  return MenuContext;
}
